module.exports = __webpack_public_path__ + "media/src/shared_components/images/plus-circle_icon-300ef389d84ab65bd933a3f7093cfe66.svg";